import React, { useEffect, useState } from "react";
import Modal from "../modals/Modal";
import style from "styled-components";
import {
  Form,
  InputContainer,
  ButtonsContainer,
  Button,
  ErrorSpan,
  ButtonsContainerTuPay,
  AmountButton
} from "./DepositElements";
import { useTranslation } from "react-i18next";
import { formatNumber, toLocaleString } from "../../utils/tools";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../features/user/userSlice";
import usdtpasarelas from '../../assets/images/binancepay12.png';
import Rbetterbro from '../../assets/images/RECARGACONBETTERBRO.svg';
import { selectLimites } from "../../features/limitaciones/limitacionesSlice";

const FormBinanceOtro = ({
  form,
  handleChange,
  handleClose,
  handleSubmit,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false)
  const limitaciones = useSelector(selectLimites);

  const monedasLimites = {
    MXN: {minimo: 20, maximo: 200000},
    ARS: {minimo: 2000, maximo: 20000000},
    BRL: {minimo: 10, maximo: 100000},
    CLP: {minimo:2000, maximo: 20000000},
    BOB: {minimo:10, maximo: 100000},
    COP: {minimo:5000, maximo: 50000000},
    DOP: {minimo:500, maximo: 5000000},
    'Bs.S': {minimo:40, maximo: 500000},
    EUR: {minimo: 1, maximo: 20000},
    $: {minimo: 1, maximo: 20000},
  }

  const [minimo, setMinimo] = useState(monedasLimites[moneda].minimo)
  const [maximo, setMaximo] = useState(monedasLimites[moneda].maximo)

  useEffect(()=>{
    if(limitaciones.minimo_deposito>0 && limitaciones.minimo_deposito > minimo) setMinimo(limitaciones.minimo_deposito) 
    if(limitaciones.maximo_deposito>0 && limitaciones.maximo_deposito < maximo) setMaximo(limitaciones.maximo_deposito) 
  },[limitaciones])

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  const changeAmount = (valor) => {
    handleMonto({target: {value: valor, name: 'monto1'}});
  }

  return (
    <Form className={'tupay'}>
    <InputContainer>
      <label>{t("deposit.lbl-amount")}</label>
      </InputContainer>
      {
        moneda === 'MXN' ? (
          <AmountButton>
            <Button onClick={() => {changeAmount('100,00')}}>MXN/100</Button>
            <Button onClick={() => {changeAmount('200,00')}}>MXN/200</Button>
            <Button onClick={() => {changeAmount('500,00')}}>MXN/500</Button>
            <Button onClick={() => {changeAmount('1.000,00')}}>MXN/1.000</Button>
          </AmountButton>
        ) : moneda === 'ARS' ? (
          <AmountButton>
            <Button onClick={() => {changeAmount('2.000,00')}}>2.000 ARS</Button>
            <Button onClick={() => {changeAmount('5.000,00')}}>5.000 ARS</Button>
            <Button onClick={() => {changeAmount('10.000,00')}}>10.000 ARS</Button>
            <Button onClick={() => {changeAmount('50.000,00')}}>50.000 ARS</Button>
          </AmountButton>
        ) : moneda === 'BRL' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('50,00')}}>BRL/50</Button>
            <Button onClick={() => {changeAmount('100,00')}}>BRL/100</Button>
            <Button onClick={() => {changeAmount('200,00')}}>BRL/200</Button>
            <Button onClick={() => {changeAmount('500,00')}}>BRL/500</Button>
          </AmountButton>
        ) : moneda === 'CLP' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('3.000,00')}}>3.000 CLP</Button>
            <Button onClick={() => {changeAmount('5.000,00')}}>5.000 CLP</Button>
            <Button onClick={() => {changeAmount('10.000,00')}}>10.000 CLP</Button>
            <Button onClick={() => {changeAmount('50.000,00')}}>50.000 CLP</Button>
          </AmountButton>
        ): moneda === 'BOB' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('20,00')}}>20 BOB</Button>
            <Button onClick={() => {changeAmount('50,00')}}>50 BOB</Button>
            <Button onClick={() => {changeAmount('100,00')}}>100 BOB</Button>
            <Button onClick={() => {changeAmount('200,00')}}>200 BOB</Button>
          </AmountButton>
        ): moneda === 'COP' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('10.000,00')}}>10.000 COP</Button>
            <Button onClick={() => {changeAmount('20.000,00')}}>20.000 COP</Button>
            <Button onClick={() => {changeAmount('30.000,00')}}>30.000 COP</Button>
            <Button onClick={() => {changeAmount('50.000,00')}}>50.000 COP</Button>
          </AmountButton>
        ): moneda === 'DOP' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('700,00')}}>700 DOP</Button>
            <Button onClick={() => {changeAmount('900,00')}}>900 DOP</Button>
            <Button onClick={() => {changeAmount('1.000,00')}}>1.000 DOP</Button>
            <Button onClick={() => {changeAmount('2.000,00')}}>2.000 DOP</Button>
          </AmountButton>
        ): moneda === 'Bs.S' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('50,00')}}>50 VES</Button>
            <Button onClick={() => {changeAmount('100,00')}}>100 VES</Button>
            <Button onClick={() => {changeAmount('200,00')}}>200 VES</Button>
            <Button onClick={() => {changeAmount('500,00')}}>500 VES</Button>
          </AmountButton>
        ): moneda === 'EUR' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('5,00')}}>5 EUR</Button>
            <Button onClick={() => {changeAmount('10,00')}}>10 EUR</Button>
            <Button onClick={() => {changeAmount('50,00')}}>50 EUR</Button>
            <Button onClick={() => {changeAmount('100,00')}}>100 EUR</Button>
          </AmountButton>
        ): moneda === '$' ? (
           <AmountButton>
            <Button onClick={() => {changeAmount('5,00')}}>$5</Button>
            <Button onClick={() => {changeAmount('10,00')}}>$10</Button>
            <Button onClick={() => {changeAmount('50,00')}}>$50</Button>
            <Button onClick={() => {changeAmount('100,00')}}>$100</Button>
          </AmountButton>
        ):null
      }

      <InputContainer>
        <input
          type="text"
          placeholder="0,00"
          name="monto1"
          value={form.monto1}
          onChange={(e) => handleMonto(e)}
        />

      {monto < minimo && blur && (
        <ErrorSpan>
          {t("deposit.amount-greater-than")} {toLocaleString(minimo)} {moneda === "Bs.S" ? "VES" : moneda}{" "}
        </ErrorSpan>
      )}

      {monto > maximo && blur && (
        <ErrorSpan>
          {t("deposit.amount-less-than")} {toLocaleString(maximo)} {moneda === "Bs.S" ? "VES" : moneda}{" "}
        </ErrorSpan>
      )}

        {/* {limitaciones.minimo_deposito===0 && <>
          {moneda === 'MXN' && monto < 20 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 20 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'ARS' && monto < 2000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 2.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'BRL' && monto < 10 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 10 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'CLP' && monto < 2000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 2.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'BOB' && monto < 10 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 10 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'COP' && monto < 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 5.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'DOP' && monto < 500 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 500 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'Bs.S' && monto < 40 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 40 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'EUR' && monto < 1 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 1 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === '$' && monto < 1 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {moneda}1{" "}
          </ErrorSpan>
        )}
        
        </>}

        {limitaciones.maximo_deposito===0 && <>
        {moneda === 'MXN' && monto > 200000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 200.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'ARS' && monto > 20000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 20.000.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'BRL' && monto > 100000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 100.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'CLP' && monto > 20000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 20.000.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'BOB' && monto > 100000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 100.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'COP' && monto > 50000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 50.000.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'DOP' && monto > 5000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'Bs.S' && monto > 500000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 500.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'EUR' && monto > 20000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 20.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === '$' && monto > 20000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} {moneda}20.000{" "}
          </ErrorSpan>
        )}
        
        </>}

        {limitaciones.minimo_deposito>0 && <>
          {moneda === 'MXN' && (limitaciones.minimo_deposito > 20
                ? monto < limitaciones.minimo_deposito
                : monto < 20) && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {limitaciones.minimo_deposito > 20
                    ? limitaciones.minimo_deposito
                    : "20"} {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'ARS' && (limitaciones.minimo_deposito > 2000
                ? monto < limitaciones.minimo_deposito
                : monto < 2000)  && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {t("deposit.amount-greater-than")} {limitaciones.minimo_deposito > 2000
                    ? limitaciones.minimo_deposito
                    : "2.000"} {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'BRL' && (limitaciones.minimo_deposito > 10
                ? monto < limitaciones.minimo_deposito
                : monto < 10) && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {t("deposit.amount-greater-than")} {limitaciones.minimo_deposito > 10
                    ? limitaciones.minimo_deposito
                    : "10"} {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'CLP' && (limitaciones.minimo_deposito > 2000
                ? monto < limitaciones.minimo_deposito
                : monto < 2000) && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {limitaciones.minimo_deposito > 2000
                    ? limitaciones.minimo_deposito
                    : "2.000"} {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'BOB' && (limitaciones.minimo_deposito > 10
                ? monto < limitaciones.minimo_deposito
                : monto < 10)  && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {limitaciones.minimo_deposito > 10
                    ? limitaciones.minimo_deposito
                    : "10"} {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'COP' && (limitaciones.minimo_deposito > 5000
                ? monto < limitaciones.minimo_deposito
                : monto < 5000) && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {limitaciones.minimo_deposito > 5000
                    ? limitaciones.minimo_deposito
                    : "5.000"}  {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'DOP' && (limitaciones.minimo_deposito > 500
                ? monto < limitaciones.minimo_deposito
                : monto < 500) && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {limitaciones.minimo_deposito > 500
                    ? limitaciones.minimo_deposito
                    : "500"}  {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'Bs.S' && (limitaciones.minimo_deposito > 40
                ? monto < limitaciones.minimo_deposito
                : monto < 40) && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {limitaciones.minimo_deposito > 40
                    ? limitaciones.minimo_deposito
                    : "40"} {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'EUR' && (limitaciones.minimo_deposito > 1
                ? monto < limitaciones.minimo_deposito
                : monto < 1) && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {limitaciones.minimo_deposito > 1
                    ? limitaciones.minimo_deposito
                    : "1"} {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === '$' && (limitaciones.minimo_deposito > 1
                ? monto < limitaciones.minimo_deposito
                : monto < 1) && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {moneda}{limitaciones.minimo_deposito > 1
                    ? limitaciones.minimo_deposito
                    : "1"}{" "}
          </ErrorSpan>
        )}
        </>}

        {limitaciones.maximo_deposito>0 && <>
          {moneda === 'MXN' && (limitaciones.maximo_deposito < 20
                ? monto > limitaciones.maximo_deposito
                : monto > 20) && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {limitaciones.maximo_deposito < 20
                    ? limitaciones.maximo_deposito
                    : "20"} {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'MXN' && (limitaciones.maximo_deposito < 200000
                ? monto > limitaciones.maximo_deposito
                : monto > 200000) && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} {limitaciones.maximo_deposito < 200000
                    ? limitaciones.maximo_deposito
                    : "200.000"} {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'ARS' && monto < 2000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 2.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'ARS' && monto > 20000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 20.000.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'BRL' && monto < 10 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 10 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'BRL' && monto > 100000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 100.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'CLP' && monto < 2000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 2.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'CLP' && monto > 20000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 20.000.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'BOB' && monto < 10 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 10 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'BOB' && monto > 100000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 100.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'COP' && monto < 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 5.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'COP' && monto > 50000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 50.000.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'DOP' && monto < 500 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 500 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'DOP' && monto > 5000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'Bs.S' && monto < 40 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 40 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'Bs.S' && monto > 500000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 500.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'EUR' && monto < 1 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 1 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'EUR' && monto > 20000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 20.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === '$' && monto < 1 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {moneda}1{" "}
          </ErrorSpan>
        )}
        {moneda === '$' && monto > 20000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} {moneda}20.000{" "}
          </ErrorSpan>
        )}
        
        </>} */}

      </InputContainer>
      <img src={Rbetterbro} alt='Tupay' className={'tupa1'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      <img src={usdtpasarelas} alt='Pasarelas BinancePay' className={'tupa2'} style={{width:'100%', marginTop: '2%', marginLeft: '-1%'}}/>
      <ButtonsContainer style={{marginTop:'-90px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-back")}
        </Button>
        <Button
          primary={true}
         disabled={loading || monto < minimo || monto > maximo/* (monto < 20 && moneda === 'MXN') || (monto > 200000 && moneda === 'MXN') || (monto < 2000 && moneda === 'ARS') || (monto > 20000000 && moneda === 'ARS') || (monto < 10 && moneda === 'BRL') 
         || (monto > 100000 && moneda === 'BRL') || (monto < 2000 && moneda === 'CLP') || (monto > 20000000 && moneda === 'CLP') || (monto < 10 && moneda === 'BOB') || (monto > 100000 && moneda === 'BOB')
         || (monto < 5000 && moneda === 'COP') || (monto > 50000000 && moneda === 'COP') || (monto < 500 && moneda === 'DOP') || (monto > 5000000 && moneda === 'DOP') || (monto < 40 && moneda === 'Bs.S') || (monto > 500000 && moneda === 'Bs.S')
         || (monto < 1 && moneda === 'EUR') || (monto > 20000 && moneda === 'EUR') || (monto < 1 && moneda === '$') || (monto > 20000 && moneda === '$') */}
          onClick={handleSubmit}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-next")}
        </Button>
      </ButtonsContainer>
      

    </Form>
  );
};

export default FormBinanceOtro;


